/**
 * Enumération définissant les types PEI
 */
enum TYPE_PEI {
  PIBI = "PIBI",
  PENA = "PENA",
}
export default TYPE_PEI;
